import { HttpStatusCode } from '../consts/httpStatusCode'

/** The task fields a `202` body carries, camelCase because the shared `api` client camelizes keys. */
interface EnqueuedTaskResponse {
  status?: number
  data?: {
    taskId?: string
    taskIds?: string[]
  }
}

/**
 * The background tasks a mutation enqueued, in the order the Backend listed them.
 *
 * Both `201` and `202` are success; only `202` means work is still running, so a synchronous
 * response yields no ids and the caller's own toast and refresh path are left alone.
 *
 * `taskIds` appears only when one call enqueued more than one task — adding a course section to a
 * Survey Project that has both default instructor-added and default course-section questions
 * attached seeds each of them (Backend CR-336) — and `taskId` is that array's first element. So
 * the array wins when both are present: reading `taskId` alone reports the run as finished while
 * the second seed is still writing the questions the user was told to refresh for.
 */
export const getEnqueuedTaskIds = (response?: EnqueuedTaskResponse | null): string[] => {
  if (response?.status !== HttpStatusCode.ACCEPTED) return []
  const { taskId, taskIds } = response.data ?? {}
  if (taskIds !== undefined && taskIds.length > 0) return taskIds
  return taskId !== undefined ? [taskId] : []
}
